import { ToggleButtonDesignTokens } from '@primeng/themes/types/togglebutton';

interface ICustomToggleButtonDesignTokens extends ToggleButtonDesignTokens {
  root: ToggleButtonDesignTokens['root'] & {
    fontSize: string;
    custom: {
      background: string;
      color: string;
      borderColor: string;
      hoverBackground: string;
      hoverColor: string;
      hoverBorderColor: string;
      checkedBackground: string;
      checkedColor: string;
      checkedBorderColor: string;
      hoverCheckedBackground: string;
      hoverCheckedColor: string;
      hoverCheckedBorderColor: string;
    };
  };
}

export const baseToggleButtonToken: ICustomToggleButtonDesignTokens = {
  root: {
    padding: '0.3125rem 1rem 0.375rem 1rem',
    borderRadius: '0.25rem',

    fontSize: '0.6875rem',
    fontWeight: '500',
    disabledColor: '000',
    invalidBorderColor: '000',
    focusRing: {
      color: '{primary.700}',
      shadow: 'none',
    },

    custom: {
      background: '{neutral.500}',
      color: '{primary.600}',
      borderColor: '{neutral.500}',
      hoverBackground: '{neutral.500}',
      hoverColor: '{primary.600}',
      hoverBorderColor: '{primary.100}',
      checkedBackground: '{primary.500}',
      checkedColor: '{surface.0}',
      checkedBorderColor: '{primary.500}',
      hoverCheckedBackground: '{primary.600}',
      hoverCheckedColor: '{surface.0}',
      hoverCheckedBorderColor: '{primary.600}',
    },

    transitionDuration: '0.2s',
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `

    .p-togglebutton {
      background: ${dt('togglebutton.custom.background')} !important;
      color: ${dt('togglebutton.custom.color')} !important;
      border-color: ${dt('togglebutton.custom.borderColor')} !important;
      border-width: 1px !important;

      
    }
    
    .p-togglebutton-content {
      background: none !important;
      color: inherit !important;
      font-size: ${dt('togglebutton.root.fontSize')} !important;
      font-weight: ${dt('togglebutton.root.fontWeight')} !important;
    }

    .p-togglebutton.p-togglebutton-checked {
      background: ${dt('togglebutton.custom.checkedBackground')} !important;
      color: ${dt('togglebutton.custom.checkedColor')} !important;
      border-color: ${dt('togglebutton.custom.checkedBorderColor')} !important;
    }

    .p-togglebutton:not(:disabled):not(.p-togglebutton-checked):hover {
      background: ${dt('togglebutton.custom.hoverBackground')} !important;
      color: ${dt('togglebutton.custom.hoverColor')} !important;
      border-color: ${dt('togglebutton.custom.hoverBorderColor')} !important;
      border-width: 1px !important;

    }

    .p-togglebutton-checked.p-togglebutton:not(:disabled):hover {
      background: ${dt('togglebutton.custom.hoverCheckedBackground')} !important;
      color: ${dt('togglebutton.custom.hoverCheckedColor')} !important;
      border-color: ${dt('togglebutton.custom.hoverCheckedBorderColor')} !important;
    }

    `,
};
